
import {BrowserRouter, Routes, Route} from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Clients from "./pages/Clients";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ueber_uns" element={<About />} />
          <Route path="/projekte" element={<Clients />} />
          <Route path="/kontakte" element={<Contact />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
